import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const IMAGE_WIDTH = 148;
const IMAGE_CDN_WIDTH = 470;

const IMAGE_ASPECT_RATIO = 1.25;

const style = () => {
  const { colorBgPrimaryLight, colorTextMedium, colorTextError, space1, space2, space6, space10, space12 } = theme();

  const styles = StyleSheet.create({
    discount: {
      color: colorTextError,
      display: "flex",
      marginBottom: space1,
      width: "100%",
    },
    image: {
      borderColor: colorBgPrimaryLight,
      borderWidth: 1,
    },
    imagesContainer: {
      flexDirection: "row",
      flex: 1,
    },
    imagesWrapper: {
      flex: 1,
      marginRight: space1,
    },
    item: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 0,
      flexShrink: 1,
    },
    priceContent: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    priceLineThrough: {
      color: colorTextMedium,
      textDecorationLine: "line-through",
    },
    priceWithDiscount: {
      marginRight: space2,
    },
    productBrand: {
      color: colorTextMedium,
    },
    productInfo: {
      paddingTop: space2,
    },
    title: {
      marginBottom: space6,
    },
    wrapper: {
      paddingHorizontal: space10,
      paddingVertical: space12,
      width: "100%",
    },
  });

  return {
    ...styles,
    imageGap: space1,
  };
};

export { style, IMAGE_ASPECT_RATIO, IMAGE_WIDTH, IMAGE_CDN_WIDTH };
